module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_16_Effects.ed77bbcc.png";